import React, { Fragment, Component } from "react";
import { Element, Events, scrollSpy } from "react-scroll";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import GetDocsRight from "../components/Doctors/departments/section-left";
import GetDocsLeft from "../components/Doctors/departments/section-right";
import DeptList from "../components/Doctors/departments/deptList";
import SEO from "../components/SEO";

class PageAbout extends Component {
  componentDidMount() {
    Events.scrollEvent.register("begin", function (to, element) {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register("end", function (to, element) {
      console.log("end", arguments);
    });

    scrollSpy.update();
  }

  componentWillUnmount() {
    Events.scrollEvent.remove("begin");
    Events.scrollEvent.remove("end");
  }

  handleSetActive(to) {
    console.log(to);
  }

  render() {
    return (
      <Fragment>
        <Header />
        <PageHeader
          bgImg={require("../assets/img/doctors-bg.jpg")}
          title="Our Doctors in Bangalore"
          content=""
        />

        <DeptList onSetActiveFunc={this.handleSetActive} />

        <SEO />

        <Element name="obstetrics_and_gynecology" className="element">
          <GetDocsLeft
            hospitals="kcblr"
                      deptTitle="Obstetrics and Gynaecology"
            dept="obstetrics_and_gynecology"
            image="separator11.svg"
          />
        </Element>

        <Element name="paediatrics_and_neonatologist" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Paediatrics & Neonatologist"
            dept="paediatrics_and_neonatologist"
            image="separator9.svg"
          />
        </Element>

        <Element name="paediatrics_and_subspeciatilies" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Paediatric Subspecialities"
            dept="paediatrics_and_subspeciatilies"
            image="separator9.svg"
          />
        </Element>

        <Element name="developmental_pediatrics" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Developmental Paediatrics"
            dept="developmental_pediatrics"
            image="separator10.svg"
          />
        </Element>

        <Element name="fetal_medicine" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Radiology & Fetal Medicine"
            dept="fetal_medicine"
            image="separator13.svg"
          />
        </Element>
        <Element name="anaesthesia_and_critical_care" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Anaesthesia & Critical Care"
            dept="anaesthesia_and_critical_care"
            image="separator12.svg"
          />
        </Element>

        {/* 
        <Element name="endocrinology_and_diabetology" className="element">
          <GetDocsRight
            hospitals="kcblr"
            deptTitle="Endocrinology And Diabetology"
            dept="endocrinology_and_diabetology"
            image="separator15.svg"
          />
        </Element> */}

        {/* <Element name="specialists_for_mind_care" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Specialists for Psychiatric & psychological counseling"
            dept="specialists_for_mind_care"
            image="separator16.svg"
          />
        </Element> */}

        <Element name="physicians" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Physicians"
            dept="physicians"
            image="separator17.svg"
          />
        </Element>

        <Element name="surgical_specialist" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Surgical Speciality"
            dept="surgical_specialist"
            image="separator18.svg"
          />
        </Element>

        {/* <Element name="cosmetologists_and_plastic_surgeons" className="element">
          <GetDocsRight
            hospitals="kcblr"
            deptTitle="Cosmetologist and Plastic Surgery"
            dept="cosmetologists_and_plastic_surgeons"
            image="separator19.svg"
          />
        </Element>

        <Element name="infertility-and-ivf" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Fertility & IVF"
            dept="infertility_and_ivf"
            image="separator12.svg"
          />
        </Element>
        <Element name="dental" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Dental"
            dept="dental"
            image="separator12.svg"
          />
        </Element>
        <Element name="ultrasound_and_radiology" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Ultrasound and Radiology"
            dept="ultrasound_and_radiology"
            image="separator12.svg"
          />
        </Element> */}
        <Element name="other_specialities" className="element">
          <GetDocsLeft
            hospitals="kcblr"
            deptTitle="Other Specialities"
            dept="other_specialities"
            image="separator12.svg"
          />
        </Element>

        <Footer />
        <MobileMenu />
      </Fragment>
    );
  }
}

export default PageAbout;
